// src/context/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import app from "../firebase/firebaseConfig";

const AuthContext = createContext();
const auth = getAuth(app);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [securityCode, setSecurityCode] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
    });

    // Load security code from sessionStorage if present
    const storedCode = sessionStorage.getItem('securityCode');
    if (storedCode) {
      setSecurityCode(storedCode);
    }

    return () => unsubscribe();
  }, []);

  const logout = () => {
    sessionStorage.removeItem('securityCode');
    setSecurityCode(null);
    return auth.signOut(); // Optional: Only if Firebase user was signed in
  };

  return (
    <AuthContext.Provider value={{ currentUser, securityCode, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
